import { StoreShippingsSectionProps } from './store-shippings-section.types'
import styles from './store-shippings-section.module.scss'
import cl from 'classnames'
import {
  Button,
  H2,
  IconExpand,
  NoneLabel,
  SectionContainer
} from '@touche-lts/panel-ui/dist'
import { ShippingOption } from './shipping-option'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'mobx-stores/store-provider'

const StoreShippingsSectionComponent = (props: StoreShippingsSectionProps) => {
  const { className, style } = props
  const {
    storeShippingsStore: {
      hasShippings,
      shippingsList,
      onAddShippingClick,
      isShippingEditModeActive
    }
  } = useRootStore()

  return (
    <SectionContainer
      colorPreset='dark'
      className={cl(styles.container, className)}
      style={style}
    >
      <H2 colorPreset='dark'>Shipping options</H2>
      {hasShippings ? (
        <div>
          {shippingsList.map((shipping, index) => {
            return (
              <ShippingOption
                key={shipping.id}
                shipping={shipping}
                isLastInList={shippingsList.length === index + 1}
              />
            )
          })}
        </div>
      ) : (
        <NoneLabel colorPreset='dark' label='No shipping options added yet' />
      )}
      {!isShippingEditModeActive && (
        <Button
          preset='link'
          style={{ marginTop: 30 }}
          onClick={onAddShippingClick}
        >
          <IconExpand style={{ marginRight: 8, fill: styles.primary }} />
          Add{hasShippings && ' another'} option
        </Button>
      )}
    </SectionContainer>
  )
}

const StoreShippingsSection = observer(StoreShippingsSectionComponent)
export { StoreShippingsSection }
